import { useTranslation } from "@/hooks/localization/useTranslations";
import { ChangeEvent, useState } from "react";
interface Props {
  value: string;
  setValue: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
}

const minRows = 1;
const maxRows = 5;

const TextArea: React.FC<Props> = ({
  value,
  setValue,
  onBlur,
  disabled = false,
}) => {
  const t = useTranslation();
  const [rows, setRows] = useState(2);
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const textareaLineHeight = 18;
    const previousRows = event.target.rows;
    event.target.rows = minRows;
    const currentRows = ~~(
      (event.target.scrollHeight - 16) /
      textareaLineHeight
    );
    if (currentRows === previousRows) event.target.rows = currentRows;
    else if (currentRows >= maxRows) {
      event.target.rows = maxRows;
      event.target.scrollTop = event.target.scrollHeight;
    }
    setRows(currentRows < maxRows ? currentRows : maxRows);
    setValue(event.target.value);
  };

  return (
    <textarea
      disabled={disabled}
      rows={rows}
      value={value}
      placeholder={t.enter_your_note_here}
      className={"textarea"}
      onChange={handleChange}
      onBlur={onBlur}
    />
  );
};
export default TextArea;
